import { michiganKickerSharedAssetPreloader } from '../shared/asset-preloader'

export enum MI_MULTIPLIER_WHEEL_ATLAS_FRAMES {
  BACKGROUND = 'background.png',
  FLASH_PREFIX = 'flash',
  NUMBER_GLOW_SUFFIX = 'glow.png',
  PODIUM = 'podium.png',
  POINTER = 'pointer.png',
  SPOTLIGHT = 'spotlight.png',
  WHEEL_BASE = 'wheel-base.png',
  WHEEL_BLANK = 'wheel_blank.png',
  WHEEL_OUTER_RING = 'wheel_outer_ring.png',
  WHEEL_STATIC = 'wheel_static.png',
  X_GLOW = 'x-glow.png',
}

export enum MI_MULTIPLIER_WHEEL_TEXTURE_KEYS {
  ATLAS = 'MI_WHEEL_ATLAS',
}

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/wheel/`

  michiganKickerSharedAssetPreloader(scene)

  if (!scene.textures.getTextureKeys().includes(MI_MULTIPLIER_WHEEL_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      MI_MULTIPLIER_WHEEL_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/multiplier-wheel-images.json`,
      `${prefix}atlas/`,
    )
  }
}
